import { Component, Input, OnInit } from '@angular/core';

import { Usuario } from '../../../usuario';
import { isPedidoOrigemCancelamentoSogivendas, isPedidoOrigemCancelamentoERP, isPedidoOrigemCancelamentoEcommerce } from '../pedido-origem-canelamento';

interface IConfig {
    isOrigemSogivendas: boolean;
    isOrigemERP: boolean;
    isOrigemEcommerce: boolean;
    isShowUsuarioCancelamento: boolean;
}

@Component({
    selector: 'sgt-pedido-cancelamento-info',
    templateUrl: './pedido-cancelamento-info.component.html',
    styleUrls: ['./pedido-cancelamento-info.component.less']
})
export class PedidoCancelamentoInfoComponent implements OnInit {
    config: IConfig;

    @Input() origemCancelamento: number;
    @Input() dataCancelamento: Date;
    @Input() usuarioCancelamento: Usuario;
    @Input() nomeMotivoCancelado: string;
    @Input() motivoCancelamento: string;

    ngOnInit(): void {
        this.setConfig();
    }

    private setConfig() {
        this.config = {
            isOrigemSogivendas: isPedidoOrigemCancelamentoSogivendas(this.origemCancelamento),
            isOrigemERP: isPedidoOrigemCancelamentoERP(this.origemCancelamento),
            isOrigemEcommerce: isPedidoOrigemCancelamentoEcommerce(this.origemCancelamento),
            isShowUsuarioCancelamento: isPedidoOrigemCancelamentoSogivendas(this.origemCancelamento)
        };
    }
}
